import { graphqlRequest } from "./client";
import type { Track } from "./types";

/*
 * Programme copy (tracks, checklists, rubrics, finance items), served by the API so the frontend never hardcodes
 * content the programme team may edit. Loaded once and kept for the session.
 */
export interface ChecklistItem {
  key: string;
  t: string;
  d: string;
}

export interface Option {
  k: string;
  t: string;
  d: string;
  optional?: boolean;
}

export interface HygieneQuestion {
  k: string;
  q: string;
  yes: string;
  no: string;
  fix: string;
}

export interface RubricQuestion {
  key: string;
  w: number;
  q: string;
  prompt: string;
  lo: string;
  hi: string;
}

export interface Exemplar {
  name: string;
  init: string;
  home: string;
  line: string;
  feature: { title: string; problem: string; process: string; result: string };
  pieces: string[];
  contact: string;
}

export interface ProgrammeContent {
  tracks: Record<Track, { label: string; host: string; tip: string }>;
  exemplars: Record<Track, Exemplar>;
  cvBuilders: { name: string; url: string }[];
  checklist: ChecklistItem[];
  rubrics: Record<Track, RubricQuestion[]>;
  payMethods: Option[];
  clientChecklist: { k: string; t: string }[];
  finServices: Option[];
  idDocs: Option[];
  moneyDocs: Option[];
  hygiene: HygieneQuestion[];
}

let cached: Promise<ProgrammeContent> | null = null;

/** Programme copy. Public, cached for the session. */
export function fetchContent(): Promise<ProgrammeContent> {
  if (!cached) {
    cached = graphqlRequest<{ getContent: { json: string } }>(`{ getContent { json } }`, {
      authenticated: false,
    })
      .then((data) => JSON.parse(data.getContent.json) as ProgrammeContent)
      .catch((error: unknown) => {
        cached = null;
        throw error;
      });
  }
  return cached;
}

/** Test seam. */
export function resetContentCache(): void {
  cached = null;
}
